export default __webpack_public_path__ + "static/media/Dreambuilders_Membership_Alert_Icon.3ea52d8e.svg";